import { addToRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SeenMomentMarkAsSeenAction } from '../../domains/seenMoments/actions.types';

import { SeenMoments } from './types';

const initialState: SeenMoments = {};

export type SeenMomentsAsAction = SeenMomentMarkAsSeenAction;

const reducer: Reducer<SeenMoments, SeenMomentsAsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'MOMENT.MARK_AS_SEEN':
      return addToRecord(state, action.payload.id, { id: action.payload.id });
    default:
      return state;
  }
};

export default reducer;
